






































































































































































































































import Comment from '@/views/comment/components/comment.vue'
import OrderBar from '../components/order_bar.vue'
import {
  apiShoppingCartAdd,
  apiShoppingCartAddOrSub,
  apiShoppingCartRemove,
} from '@/api'
import { computed, ref } from '@vue/composition-api'
import {
  defineClassComponent,
  useActivated,
  useHandler,
  useQuery,
} from '@/hooks'
import { getDisplayPrice, previewImage, submit, Track } from '@/utils'
import {
  getInstantDeliveryGoodsModel,
  InstantDeliveryGoodsModel,
  InstantDeliveryGoodsModelProvider,
} from './model'
import { instantDeliveryBus } from '../bus'
import { keyBy } from 'lodash'
import { navigateBackOrTo, navigateTo } from '@/router'
import { showSkuPicker } from '../utils'

export default defineClassComponent(
  {
    components: {
      Comment,
      OrderBar,
    },
  },
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '商品详情页',
        }))

        // 提供标销数据
        InstantDeliveryGoodsModelProvider.provide(this.goodsData as any)

        useActivated(async () => {
          // 获取标销商品数据
          this.goodsData.value = (await getInstantDeliveryGoodsModel(
            this.query.goodsId,
          )) as any
          this.loading.value = false

          return instantDeliveryBus.on('refreshCart', () => {
            this.goodsData.value.refreshCartData()
          })
        })
      }

      query = useQuery<{
        goodsId: string
      }>({
        goodsId: {
          alias: 'id',
        },
      })

      loading = ref(true)

      bannerIndex = ref(0)

      tabIndex = ref(0)

      goodsData = ref<InstantDeliveryGoodsModel>({} as any)

      goodsDisplayPrice = computed(() =>
        getDisplayPrice(this.goodsData.value),
      )

      cartMap = computed(() =>
        keyBy(this.goodsData.value.cartData.validList, item => item.skuId),
      )

      shareParams = computed(() => ({
        title: this.goodsData.value.commodityTitle,
        desc: '',
        cover: this.goodsData.value.coverPic,
      }))

      commentData = computed(() => this.goodsData.value.commentData)

      handleServiceClick = useHandler<
        | '查看轮播图'
        | '选规格'
        | '加入购物车'
        | '更多评价'
        | '店铺'
        | '回顶'
        | '更新购物车数量'
      >({
        查看轮播图: (index: number) => {
          if (!this.goodsData.value.carousePic[index].endsWith('.mp4')) {
            previewImage({
              images: this.goodsData.value.carousePic,
              initialIndex: index,
            })
          }
        },
        选规格: () => {
          showSkuPicker({
            martId: this.goodsData.value.merchantId,
            goods: this.goodsData.value,
          })
        },
        加入购物车: () => {
          submit(async $ => {
            $.start()
            await apiShoppingCartAdd(
              {
                commodityId: this.goodsData.value.commodityId,
                skuId: this.goodsData.value.skuList[0].skuId,
                quantity: 1,
              },
              {
                businessChannel: this.goodsData.value.merchantId,
              },
            )
            instantDeliveryBus.emit('refreshCart')
            await $.success('加入购物车成功')
          })
        },
        更多评价: () => {
          navigateTo('CommentIndex', {
            id: this.query.goodsId,
          })
        },
        店铺: () => {
          navigateBackOrTo('InstantDeliveryMartIndex', {
            martId: this.goodsData.value.merchantId,
          })
        },
        回顶: () => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          })
        },
        更新购物车数量: (goodsId: string, skuId: string, delta: number) => {
          submit(async $ => {
            $.start()
            if (!this.cartMap.value[skuId]) {
              await apiShoppingCartAdd(
                {
                  commodityId: goodsId,
                  skuId: skuId,
                  quantity: 1,
                },
                {
                  businessChannel: this.goodsData.value.merchantId,
                },
              )
            } else {
              const count = this.cartMap.value[skuId].quantity + delta
              if (count <= 0) {
                await apiShoppingCartRemove(
                  {
                    idList: [this.cartMap.value[skuId].id],
                  },
                  {
                    businessChannel: this.goodsData.value.merchantId,
                  },
                )
              } else {
                await apiShoppingCartAddOrSub(
                  {
                    id: this.cartMap.value[skuId].id,
                    quantity: count,
                  },
                  {
                    businessChannel: this.goodsData.value.merchantId,
                  },
                )
              }
            }
            instantDeliveryBus.emit('refreshCart')
          })
        },
      })
    },
)
